<template>
  <div class="developer">
    <div class="part-1">
      <div class="main" style="padding-top: 140px;padding-left: 35px;">
        <div class="path">
          {{ $t('messageDetail.position') }}：
          <a
            @click="$router.push('/message')"
          >{{ $t('messageDetail.news') }}</a>
          &gt; {{ $t('messageDetail.notice') }} &gt; {{title}}
        </div>
      </div>
    </div>
    <div class="part-2">
      <div class="title">{{title}}</div>
      <div class="date">{{createdTime}}</div>
      <div class="main1"  v-html="content"></div>
    </div>
  </div>
</template>

<script>
import api from "../common/api";

export default {
  name: "weeklyDetail",

  data() {
    return {
      title: "",
      createdTime: "",
      content: ""
    };
  },

  created() {
    this.getDetail();
  },

  methods: {
    getDetail() {
      this.$axios
        .get(api.getNoticeDetail, {
          params: {
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.title = res.data.title;
          this.createdTime = res.data.createdTime;
          this.content = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less" >
@import url("../assets/css/var.less");
 
.developer {
  .part-1 {
    height: 205px;
    background-image: url("../assets/images/developer-appli-bg.jpg");
    background-repeat: no-repeat;
    background-position: top;
    background-size: 100% 140px;

    .path {
      width: 1000px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-top: 20px;

      a {
        color: rgba(102, 102, 102, 1);
      }
    }
  }
  .part-2 {
    width: 1080px;
    
    margin-top: 30px;
    background-color: rgba(255, 255, 255, 1);
    margin: 0 auto;
    padding-top: 78px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    .title {
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-bottom: 30px;
    }

    .date {
      margin-top: 30px;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 40px;
    }
  .main1 {
      width: auto;
      font-size: 16px;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      line-height: 30px;
      padding: 45px 0px  100px 0px;
      margin: 0  120px  64px  120px;
      border-top:2px dashed rgba(216,216,216,1);
     img{
        max-width: 100%;
      }
    }
  }
}
</style>
